<template>
  <div class="container-fluid solution-page-container">
    <div>
      <div class="row pdf-header">
        <img class="logo" :src="signifyLogo" alt="signify-logo" />
        <h1 class="ag-theme-blue">Calculated results</h1>
      </div>
      <div v-if="pdfSolution.module" class="row selection-item">
        <h3>Find your luminaire performance</h3>
        <LuminairePerformance
          v-if="pdfSolution.module && pdfSolution.driver"
          :module="pdfSolution.module"
          :driver="pdfSolution.driver"
          :print="true"
          :region="pdfSolution.region"
          :inputValues="pdfSolution.inputValues"
        ></LuminairePerformance>
        <div class="odd-note" v-if="!pdfSolution.isWhitelistedSolution">
          Please note: the current combination is not validated by Signify
          Lighting OEM.
        </div>
      </div>
      <div
        v-if="pdfSolution.module && pdfSolution.driver"
        class="row selection-item"
      >
        <h3>System characteristics</h3>
        <SystemCharacteristics
          v-if="pdfSolution.module"
          :module="pdfSolution.module"
          :multiLengthModules="pdfSolution.multiLengthModules"
          :driver="pdfSolution.driver"
          :region="pdfSolution.region"
          :print="true"
        ></SystemCharacteristics>
      </div>
      <div
        v-if="
          pdfSolution.module &&
            !pdfSolution.multiLengthModules.length &&
            pdfSolution.driver
        "
        class="row selection-item"
      >
        <h3>Module parameters</h3>
        <ModuleParameters
          :module="pdfSolution.module"
          :driver="pdfSolution.driver"
          :show-specs="moduleExtraSpecs()"
          :region="pdfSolution.region"
          :print="true"
        ></ModuleParameters>
      </div>
      <div
        v-if="pdfSolution.multiLengthModules.length && pdfSolution.driver"
        class="row selection-item"
      >
        <h3>Module parameters</h3>
        <MultiLengthParameters
          :modules="pdfSolution.multiLengthModules"
          :virtualModule="pdfSolution.virtualModule"
          :region="pdfSolution.region"
          :show-specs="moduleExtraSpecs()"
          :print="true"
        ></MultiLengthParameters>
      </div>
      <div v-if="pdfSolution.driver" class="row selection-item">
        <h3>Driver parameters</h3>
        <DriverParameters
          :module="pdfSolution.module"
          :driver="pdfSolution.driver"
          :region="pdfSolution.region"
          :print="true"
        ></DriverParameters>
      </div>
      <div
        v-if="pdfSolution.emergencyDrivers.length"
        class="row selection-item"
      >
        <h3>Emergency Driver parameters</h3>
        <EmergencyDriverParameters
          :emergencyDrivers="pdfSolution.emergencyDrivers"
          :print="true"
        ></EmergencyDriverParameters>
      </div>
      <div v-if="pdfSolution.sensor" class="row selection-item">
        <h3>Node parameters</h3>
        <SensorParameters
          :sensor="pdfSolution.sensor"
          :region="pdfSolution.region"
        ></SensorParameters>
      </div>
      <div v-if="pdfSolution.bridge" class="row selection-item">
        <h3>Bridge parameters</h3>
        <BridgeParameters :bridge="pdfSolution.bridge"></BridgeParameters>
      </div>
      <div v-if="pdfSolution.userComment" class="row selection-item">
        <h3>Comment</h3>
        <div class="container-fluid">
          <div class="row">
            <p>{{ pdfSolution.userComment }}</p>
          </div>
        </div>
      </div>
      <div class="row disclaimer">
        <p>
          [coming soon] This mark identifies the products that are before
          commercial release and that are not yet available for order.<br />
          [obsolete] This mark identifies the products that were phased-out and
          that are not available for order
        </p>

        <p>
          Warning on modules<br />
          Tolerance range for optical flux, efficacy and electrical voltage data
          is stated in the respective datasheet. Number of modules in parallel
          per chain might be lesser than the calculated total number of modules
          in parallel. Please refer to the respective datasheet for the exact
          numbers.
        </p>

        <p>
          Warning on drivers<br />
          Tolerance range for electrical current data is stated in the
          respective datasheet. For the lower current part of the drivers
          operating windows, the dimming level is limited by an absolute minimum
          output current of the driver. For the higher current part of the
          drivers operating windows, the CLO feature is limited by an absolute
          maximum output current of the driver. Please refer to specific LED
          driver Design-In guide. Due to the nature of the manufacturing
          processes of LED drivers the typical data of technical parameters can
          only reflect statistical figures and do not necessarily correspond to
          the actual parameters of each single product which could differ from
          the typical data. Calculations are made based on sample measurement
          data. Going below 30% of the driver’s maximum output power could
          increase the uncertainty at which the efficiency can be calculated.
          Efficiency calculations are informative and represent no warranty
          claim.
        </p>

        <p>
          Disclaimer of Warranties<br />
          The Easy Design-In Tool (“Tool”), the content (including, without
          limitation, text, images, graphics, links and other materials) of the
          Tool (“Content”) and results generated by using the Tool (“Calculated
          Results”) are provided “as is” and “as available”. Signify B.V. and
          its affiliates, partners, licensors and suppliers hereby expressly
          disclaim any representation or warranties of any kind, express or
          implied, including without limitation warranties of merchantability,
          satisfactory quality, fitness for any particular purpose,
          non-infringement, or as to the operation of the Tool. Neither Signify
          B.V., nor its affiliates, partners, licensors and suppliers warrants
          or makes any representation that (i) the Tool will be uninterrupted,
          timely, secure or error free, or (ii) the Calculated Results will be
          correct, complete, accurate, reliable or otherwise meet your
          requirements.
        </p>

        <p>
          Limitation of Liability<br />
          In no event will Signify B.V., or any of its affiliates, or owners or
          licensors of, or authors or contributors to, the Tool or the Content,
          be liable for indirect, incidental, special, exemplary or
          consequential damages (including, but not limited to, loss of profit,
          lost savings, loss of reputation, loss of goodwill, loss of use, loss
          of data or business interruption) arising out of or in connection with
          your use of the Tool (including resulting from the use of the
          Calculated Results or any report generated by the Tool) whether or not
          such damages are based on tort, warranty, contract or otherwise, even
          if advised of the possibility of such damage. Some jurisdictions do
          not allow the exclusion or limitation of liability for consequential
          or indirect damages, so the above limitation or exclusion may not
          apply to you. In on event shall Signify B.V.’s (or that of its
          affiliates, or owners or licensors of, or authors or contributors to,
          the Tool or the Content) total liability to you, arising out of or
          relating to the use of the Tool (whether or not such damages are based
          on tort, warranty, contract or otherwise) exceeds the amount of fifty
          Euro (€50). Your use of the Easy Design-In Tool and the Calculated
          Results are further subject to the Terms of Use – Easy Design-In Tool
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import signifyLogo from "@/assets/img/SIGNIFY_LOGO_RGB@2x.png";
import {
  MAX_VF_AND_MIN_LUM_FLUX,
  THERMAL_POWER_PER_LED_PACKAGE,
  RTH_MODULE_CALCULATIONS
} from "@/service/Constants";

export default {
  name: "PdfLayout",
  data() {
    return {
      signifyLogo: signifyLogo,
      pdfSolution: {},
      aclFeatures: null
    };
  },
  created() {
    this.pdfSolution = JSON.parse(localStorage.getItem("pdfPayload"));
    this.aclFeatures = JSON.parse(localStorage.getItem("aclFeatures"));
  },
  methods: {
    moduleExtraSpecs() {
      let result = [];
      this.aclFeatures.includes(MAX_VF_AND_MIN_LUM_FLUX) &&
        result.push("maximumForwardVoltage", "minLuminousFluxPerModule");
      this.aclFeatures.includes(THERMAL_POWER_PER_LED_PACKAGE) &&
        result.push("thermalPowerPerLedPackage");
      this.aclFeatures.includes(RTH_MODULE_CALCULATIONS) &&
        result.push("rthModuleCalculation");
      return result;
    }
  }
};
</script>
<style lang="scss" scoped>
.pdf-header {
  align-items: center;
  margin-bottom: 30px;

  h1 {
    margin-bottom: 7px;
  }

  .logo {
    display: block;
    width: 160px;
    margin: 0 12px 0 6px;
    cursor: pointer;
  }
}

.selection-item {
  margin-bottom: 30px;
}

.disclaimer {
  font-size: 0.6rem;
}

.odd-note {
  padding: 1rem 0 0 0;
  color: $secondary;
}

@media print {
  .row {
    page-break-inside: avoid;
  }
}
</style>
